// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__EwVYi","container":"Footer_container__CmmG-","footer_links":"Footer_footer_links__FX5O+","SMicons":"Footer_SMicons__Tx3cL"};